import { render, staticRenderFns } from "./ChatTab.vue?vue&type=template&id=204152fc&scoped=true"
import script from "./ChatTab.vue?vue&type=script&lang=js"
export * from "./ChatTab.vue?vue&type=script&lang=js"
import style0 from "./ChatTab.vue?vue&type=style&index=0&id=204152fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204152fc",
  null
  
)

export default component.exports